import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";

export const TimeSlotButton = styled(Button)`
  margin: 5px;
  width: 134px;
  padding: 4px 8px;
  font-size: 0.75rem;
  color: black !important;
  border-color: grey !important;
`;

export const TimeSlotDialog = styled(Dialog)`
  & .MuiPaper-root {
    width: 80%;
    max-width: 900px;
    height: 70vh;
  }
`;
